import { render, staticRenderFns } from "./CallDetailsRequested.vue?vue&type=template&id=c8644990&"
import script from "./CallDetailsRequested.vue?vue&type=script&lang=js&"
export * from "./CallDetailsRequested.vue?vue&type=script&lang=js&"
import style0 from "./CallDetailsRequested.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports